/**
 * BAU CART — bau-cart.js v14.0 (multi-pettorina, dati reali Shopify)
 * TUTTO IN UN FILE: reward bar + auto-add/remove premi + line-item + leash swap
 *
 * Soglie (centesimi): €19,90=1990 | €29,90=2990 | €39,90=3990
 *
 * v11.0 — FIX DEFINITIVO:
 *   - Portabustine: risoluzione variante da QUALSIASI opzione + fallback /products/*.js.
 *   - Guinzaglio: scelta/swap XS-M ⇄ L-XXL sempre guidata dalla Pettorina.
 *   - Preserva colore, quantità e proprietà durante lo swap.
 *
 * Storico v10.0:
 *   1) handle pettorina corretto: 'pettorina-personalizzata-cane'
 *      (era 'pettorina-personalizzabile-cane', non corrispondeva al
 *      prodotto reale → causava mancato match colore/taglia in
 *      alcune risoluzioni automatiche)
 *   2) aggiunto warning esplicito se m3ProductId risulta null, per
 *      diagnosticare subito un eventuale problema di handle prodotto
 *      portabustine-led-luminoso-gratuito
 *   3) NUOVO meccanismo "leash swap": se la Pettorina nel carrello
 *      ha taglia L/XL/XXL/XXXL, il Guinzaglio nel carrello (se
 *      presente) viene automaticamente sostituito con la variante
 *      corrispondente di guinzaglio-baugrip; se la taglia è XS/S/M,
 *      viceversa si torna a guinzaglio-riflettente-per-cani.
 *      Richiede window.__BAU_LEASH__ (iniettato da cart-drawer.liquid).
 */
(function () {
  'use strict';
  if (window.__bauCartV14Loaded) return;
  window.__bauCartV14Loaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var PORTABUSTINE_COLORS = ['rosso', 'rosa', 'verde', 'grigio'];
  var PORTABUSTINE_COLOR_ALIASES = {
    rosa: ['rosa', 'pink', 'sakura', 'blush'],
    rosso: ['rosso', 'red', 'crimson'],
    verde: ['verde', 'green', 'lucky'],
    grigio: ['grigio', 'grey', 'gray', 'midnight']
  };
  var PORTABUSTINE_DEFAULT_COLOR = 'grigio';

  var COLOR_SOURCE_HANDLES = [
    'pettorina-personalizzata-cane',
    'guinzaglio-riflettente-per-cani',
    'guinzaglio-baugrip'
  ];

var REWARDS = {
    m2: { vid: null, pid: null, threshold: 2990, label: 'BauRing™ Aggancio Frontale No-Pull',
          handle: 'aggancio-frontale-gratuito' },
    mBook: { vid: null, pid: null, threshold: 3990, label: 'BauBook™ Uscita Perfetta',
          handle: 'baubook-uscita-perfetta-gratuito' },
    m3: { vid: null, pid: null, threshold: 3990, label: 'Portabustine LED Gratuito',
          handle: 'portabustine-led-luminoso-gratuito' }
  };
  var THRESHOLDS = { t1: 1990, t2: 2990, t3: 3990 };

function resolveM2Config() {
    if (REWARDS.m2.pid) return;
    var cfg = window.__BAU_REWARDS__;
    if (!cfg) return;
    if (cfg.m2ProductId && !REWARDS.m2.pid) {
      REWARDS.m2.pid = Number(cfg.m2ProductId);
      console.log('[BauReward] m2 front D-Ring pid resolved:', REWARDS.m2.pid);
    }
  }

  function frontRingTargetFromHarnessSize(size) {
    var s = norm(size).replace(/\s+/g, '');
    if (s === 'xxs' || s === 'xs') return 'xxs-xs';
    if (s === 's') return 's';
    if (s === 'm') return 'm';
    if (s === 'l' || s === 'xl' || s === 'xxl' || s === 'xxxl') return 'l-xxl';
    return null;
  }

  function frontRingVariantMatches(variant, target) {
    if (!variant || !target) return false;
    var values = [];
    if (Array.isArray(variant.options)) values = values.concat(variant.options);
    values.push(variant.title, variant.option1, variant.option2, variant.option3);
    values = values.filter(Boolean).map(function (v) {
      return norm(v).replace(/\s+/g, '').replace(/[–—]/g, '-');
    });
    if (target === 'xxs-xs') return values.some(function (v) { return v === 'xxs-xs' || v === 'xxs/xs' || v === 'xxsxs'; });
    if (target === 'l-xxl') return values.some(function (v) { return v === 'l-xxl' || v === 'l/xxl' || v === 'lxxl'; });
    return values.some(function (v) { return v === target; });
  }

  function resolveM2VariantId(cart) {
    var cfg = window.__BAU_REWARDS__ || {};
    var size = findHarnessSize(cart || { items: [] });
    var target = frontRingTargetFromHarnessSize(size);
    if (!target) return null;
    var list = Array.isArray(cfg.m2VariantList) ? cfg.m2VariantList : [];
    var exact = list.find(function (variant) {
      return variant && variant.available !== false && frontRingVariantMatches(variant, target);
    });
    if (!exact) {
      exact = list.find(function (variant) { return variant && frontRingVariantMatches(variant, target); });
    }
    return exact && Number(exact.id) ? Number(exact.id) : null;
  }

  var _m2ProductPromise = null;
  function ensureM2VariantId(cart) {
    var immediate = resolveM2VariantId(cart);
    if (immediate) return Promise.resolve(immediate);
    var size = findHarnessSize(cart || { items: [] });
    var target = frontRingTargetFromHarnessSize(size);
    if (!target) return Promise.resolve(null);

    if (!_m2ProductPromise) {
      _m2ProductPromise = fetch(ROOT + 'products/' + REWARDS.m2.handle + '.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        if (!response.ok) throw new Error('front D-Ring product ' + response.status);
        return response.json();
      }).then(function (product) {
        if (product && product.id && !REWARDS.m2.pid) REWARDS.m2.pid = Number(product.id);
        return product;
      }).catch(function (error) {
        _m2ProductPromise = null;
        throw error;
      });
    }

    return _m2ProductPromise.then(function (product) {
      var variants = product && Array.isArray(product.variants) ? product.variants : [];
      var match = variants.find(function (v) { return v && v.available !== false && frontRingVariantMatches(v, target); }) ||
                  variants.find(function (v) { return v && frontRingVariantMatches(v, target); });
      return match && Number(match.id) ? Number(match.id) : null;
    });
  }


  function canonicalRewardColor(raw) {
    var value = norm(raw);
    if (!value) return null;
    var keys = Object.keys(PORTABUSTINE_COLOR_ALIASES);
    for (var i = 0; i < keys.length; i++) {
      var canonical = keys[i];
      var aliases = PORTABUSTINE_COLOR_ALIASES[canonical] || [];
      if (aliases.some(function(alias) { return value === alias || value.indexOf(alias) !== -1; })) {
        return canonical;
      }
    }
    return PORTABUSTINE_COLORS.indexOf(value) !== -1 ? value : null;
  }

  function resolveBookConfig() {
    if (REWARDS.mBook.pid && REWARDS.mBook.vid) return;
    var cfg = window.__BAU_REWARDS__;
    if (!cfg) return;
    if (cfg.mBookProductId && !REWARDS.mBook.pid) REWARDS.mBook.pid = Number(cfg.mBookProductId);
    if (cfg.mBookVariantId && !REWARDS.mBook.vid) REWARDS.mBook.vid = Number(cfg.mBookVariantId);
  }

  function resolveM3Config() {
    if (REWARDS.m3.pid) return;
    var cfg = window.__BAU_REWARDS__;
    if (!cfg) {
      console.warn('[BauReward] window.__BAU_REWARDS__ non trovato — verifica che lo script di config in cart-drawer.liquid venga eseguito prima di bau-cart.js');
      return;
    }
    if (cfg.m3ProductId) {
      REWARDS.m3.pid = Number(cfg.m3ProductId);
      console.log('[BauReward] m3 pid resolved:', REWARDS.m3.pid);
    } else {
      console.warn('[BauReward] m3ProductId è null/vuoto in window.__BAU_REWARDS__ — il prodotto con handle "portabustine-led-luminoso-gratuito" non è stato trovato o non è disponibile. L\'auto-add del premio NON funzionerà finché questo non è risolto.');
    }
  }

  function resolveM3Color(cartItems) {
    var found = null;
    for (var i = 0; i < cartItems.length; i++) {
      var item = cartItems[i];
      var itemHandle = item.handle || '';
      if (COLOR_SOURCE_HANDLES.indexOf(itemHandle) === -1) continue;
      var colorRaw = '';
      if (item.variant_options && item.variant_options[0]) {
        colorRaw = item.variant_options[0];
      } else if (item.option1) {
        colorRaw = item.option1;
      }
      var canonical = canonicalRewardColor(colorRaw);
      if (canonical) {
        found = canonical;
        console.log('[BauReward] color-match da', itemHandle, '→', found, '(raw:', colorRaw + ')');
        break;
      }
    }
    var result = found || PORTABUSTINE_DEFAULT_COLOR;
    console.log('[BauReward] m3 colore scelto:', result);
    return result;
  }

  function norm(value) {
    return String(value == null ? '' : value)
      .toLowerCase()
      .trim()
      .replace(/[àáâãäå]/g, 'a')
      .replace(/[èéêë]/g, 'e')
      .replace(/[ìíîï]/g, 'i')
      .replace(/[òóôõö]/g, 'o')
      .replace(/[ùúûü]/g, 'u');
  }

  function variantHasColor(variant, color) {
    var wanted = norm(color);
    if (!wanted || !variant) return false;

    var values = [];
    if (Array.isArray(variant.options)) values = values.concat(variant.options);
    if (variant.option1) values.push(variant.option1);
    if (variant.option2) values.push(variant.option2);
    if (variant.option3) values.push(variant.option3);
    if (variant.title) values.push(variant.title);

    return values.some(function (value) {
      var n = norm(value);
      return n === wanted || n.indexOf(wanted) !== -1;
    });
  }

  function firstNumericValue(obj) {
    if (!obj) return null;
    for (var key in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;
      var value = Number(obj[key]);
      if (value) return value;
    }
    return null;
  }

  function resolveM3VariantId(color) {
    var cfg = window.__BAU_REWARDS__ || {};
    var direct = cfg.m3Variants && Number(cfg.m3Variants[color]);
    if (direct) return direct;

    var list = Array.isArray(cfg.m3VariantList) ? cfg.m3VariantList : [];
    var exact = list.find(function (variant) {
      return variant && variant.available !== false && variantHasColor(variant, color);
    });
    if (exact && Number(exact.id)) return Number(exact.id);

    var defaultId = Number(cfg.m3DefaultVariantId);
    if (defaultId) return defaultId;

    var fallbackColor = cfg.m3Variants && (
      Number(cfg.m3Variants[PORTABUSTINE_DEFAULT_COLOR]) ||
      Number(cfg.m3Variants.grigio)
    );
    if (fallbackColor) return fallbackColor;

    var firstList = list.find(function (variant) {
      return variant && variant.available !== false && Number(variant.id);
    });
    if (firstList) return Number(firstList.id);

    return firstNumericValue(cfg.m3Variants);
  }

  var _m3ProductPromise = null;

  function ensureM3VariantId(color) {
    var immediate = resolveM3VariantId(color);
    if (immediate) return Promise.resolve(immediate);

    if (!_m3ProductPromise) {
      _m3ProductPromise = fetch(ROOT + 'products/' + REWARDS.m3.handle + '.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (response) {
        if (!response.ok) throw new Error('product ' + response.status);
        return response.json();
      })
      .then(function (product) {
        if (product && product.id && !REWARDS.m3.pid) {
          REWARDS.m3.pid = Number(product.id);
        }
        return product;
      })
      .catch(function (error) {
        _m3ProductPromise = null;
        throw error;
      });
    }

    return _m3ProductPromise.then(function (product) {
      var variants = product && Array.isArray(product.variants) ? product.variants : [];
      var match = variants.find(function (variant) {
        return variant && variant.available !== false && variantHasColor(variant, color);
      });
      if (!match) {
        match = variants.find(function (variant) {
          return variant && variant.available !== false;
        });
      }
      return match && Number(match.id) ? Number(match.id) : null;
    });
  }

  var _rewardInCart = { m2: false, mBook: false, m3: false };
  var _rewardLock   = { m2: false, mBook: false, m3: false };
  var _broadcasting = false;

  var _cartItems = [];

  function cacheCart(cart) {
    if (!cart || !cart.items) return;
    _cartItems = cart.items.map(function (i) {
      return {
        variant_id: i.variant_id,
        key: i.key,
        properties: i.properties || {},
        product_id: i.product_id,
        handle: i.handle || '',
        url: i.url || '',
        option1: i.option1 || '',
        option2: i.option2 || '',
        quantity: i.quantity || 1,
        title: i.title || '',
        variant_options: i.variant_options || []
      };
    });
  }

  function syncRewardState(cart) {
    resolveM2Config();
    resolveBookConfig();
    resolveM3Config();
    ['m2', 'mBook', 'm3'].forEach(function (key) {
      var pid = REWARDS[key].pid;
      if (!pid) return;
      _rewardInCart[key] = (cart.items || []).some(function (i) {
        return i.product_id === pid && (
          (i.properties && String(i.properties._reward) === '1') ||
          (i.properties && String(i.properties._bundle_gift) === 'true')
        );
      });
    });
  }

  function getSections() {
    var sections = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true, detail: { sections: sections }
      }));
    } catch (e) {}
    return sections.length ? sections : null;
  }

  function calcRewardTotal(cart) {
    var total = (cart.items || [])
      .filter(function (i) { return i.requires_shipping; })
      .reduce(function (s, i) { return s + i.final_line_price; }, 0);
    var disc = (cart.cart_level_discount_applications || [])
      .reduce(function (s, d) { return s + (d.total_allocated_amount || 0); }, 0);
    return Math.max(0, total - disc);
  }

  var _lastRenderTotal = -1;

  function renderBar(total, cart) {
    var hasHarness = !!(cart && (cart.items || []).some(function (item) {
      return item.handle === 'pettorina-personalizzata-cane';
    }));
    var signature = total + '|' + (hasHarness ? '1' : '0');
    if (signature === _lastRenderTotal) return;
    _lastRenderTotal = signature;

    requestAnimationFrame(function () {
      var barEl = document.getElementById('bau-reward-bar');
      var fill  = document.getElementById('brb-fill');
      var msg   = document.getElementById('brb-message');
      if (!barEl || !fill || !msg) return;

      var T = THRESHOLDS;
      var m1 = total >= T.t1, m2 = total >= T.t2 && hasHarness, m3 = total >= T.t3;
      var pct = 0;
      if (total >= T.t3) pct = 100;
      else if (total >= T.t2) pct = 50 + ((total - T.t2) / Math.max(1, T.t3 - T.t2)) * 50;
      else if (total >= T.t1) pct = ((total - T.t1) / Math.max(1, T.t2 - T.t1)) * 50;
      pct = Math.max(0, Math.min(100, pct));

      fill.style.width = pct.toFixed(2) + '%';

      var dot1 = document.getElementById('brb-dot-1');
      var dot2 = document.getElementById('brb-dot-2');
      var dot3 = document.getElementById('brb-dot-3');

      /* Aggiorna anche UI/tooltip/icon dei reward BAU. */
      var rewardCfg = window.__BAU_REWARDS__ || {};
      if (dot2) {
        var dot2Tip = dot2.querySelector('.brb__dot-tooltip');
        if (dot2Tip) dot2Tip.textContent = (rewardCfg.labels && rewardCfg.labels.m2) || 'Front D-Ring Gratuito';
      }
      if (dot3) {
        var dot3Tip = dot3.querySelector('.brb__dot-tooltip');
        if (dot3Tip && rewardCfg.labels && rewardCfg.labels.m3) dot3Tip.textContent = rewardCfg.labels.m3;
      }

      if (dot1) dot1.classList.toggle('brb__dot--unlocked', m1);
      if (dot2) dot2.classList.toggle('brb__dot--unlocked', m2);
      if (dot3) dot3.classList.toggle('brb__dot--unlocked', m3);

      var lblEls = barEl.querySelectorAll('.brb__labels-row .brb__label');
      if (lblEls[0]) lblEls[0].classList.toggle('brb__label--unlocked', m1);
      if (lblEls[1]) lblEls[1].classList.toggle('brb__label--unlocked', m2);
      if (lblEls[2]) lblEls[2].classList.toggle('brb__label--unlocked', m3);

      var html;
      if (m3 && hasHarness) html = 'Hai sbloccato tutti i tuoi regali!';
      else if (m3) html = 'Hai sbloccato <strong>BauBook</strong> e <strong>Portabustine LED</strong>!';
      else if (m2) html = '<strong>Front D-Ring</strong> sbloccato! Aggiungi <strong>' + fmt(T.t3 - total) + '</strong> per <strong>BauBook + Portabustine</strong> 🎁';
      else if (total >= T.t2) html = 'BauRing gratuito con una pettorina. Aggiungine una per riceverlo.';
      else if (m1) html = '<strong>BauPrime</strong> sbloccato! Aggiungi <strong>' + fmt(T.t3 - total) + '</strong> per sbloccare <strong>BauBook + Portabustine</strong>.';
      else         html = 'Aggiungi <strong>' + fmt(T.t1 - total) + '</strong> per sbloccare <strong>BauPrime</strong> 🎁';

      msg.innerHTML = html;
      msg.className = 'brb__message' + (m3 ? ' brb__message--complete' : '');
      barEl.dataset.total = String(total);
    });
  }

  function fmt(cents) {
    try {
      return new Intl.NumberFormat('it-IT', {
        style: 'currency', currency: 'EUR',
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) { return '\u20AC' + (cents / 100).toFixed(2); }
  }

  function notifyImpact(cart, sections, openDrawer) {
    renderBar(calcRewardTotal(cart), cart);

    var detail = { cart: cart };
    if (sections) detail.sections = sections;

    _broadcasting = true;
    if (openDrawer) {
      document.documentElement.dispatchEvent(
        new CustomEvent('variant:add', { bubbles: true, detail: detail })
      );
    }
    setTimeout(function () {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', { bubbles: true, detail: detail })
      );
      setTimeout(function () { _broadcasting = false; }, 100);
    }, openDrawer ? 50 : 0);
  }

  function doFetchCart(cb) {
    fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(cb)
      .catch(function (e) { console.error('[BauCart] fetchCart:', e); });
  }

  function cartAdd(body, cb, onErr) {
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(cb)
    .catch(function (e) { console.error('[BauCart] add err:', e); if (onErr) onErr(); });
  }

  function cartChange(body, cb, onErr) {
    fetch(ROOT + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
    .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
    .then(cb)
    .catch(function (e) { console.error('[BauCart] change err:', e); if (onErr) onErr(); });
  }

  function isOnlyBundleGift(cart, pid) {
    var items = cart.items || [];
    var hasReward = items.some(function (i) {
      return i.product_id === pid &&
             i.properties && String(i.properties._reward) === '1';
    });
    var hasBundleGift = items.some(function (i) {
      return i.product_id === pid &&
             i.properties && String(i.properties._bundle_gift) === 'true';
    });
    return hasBundleGift && !hasReward;
  }

  function findRewardLine(cart, pid) {
    return (cart.items || []).find(function (i) {
      return i.product_id === pid &&
             i.properties && String(i.properties._reward) === '1';
    }) || null;
  }

/* ═══════════════════════════════════════════════════════════
     REGALI SOGLIA — sincronizzazione seriale e verifica reale.
     BauRing rimane gestito per ogni pettorina da planRingCart.
     Al raggiungimento di €39,90: BauBook + portabustine, uno dopo l'altro.
     Non confondere una chiamata /cart/add.js riuscita con un regalo
     realmente presente: dopo OGNI modifica leggiamo /cart.js.
  ═══════════════════════════════════════════════════════════ */
  var _giftSyncPromise = null;
  var _giftSyncPending = false;
  var _giftCatalog = {};
  var _giftRetryAfter = 0;
  var _giftRetryTimer = null;

  function freshCartForGifts() {
    return fetch(ROOT + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Lettura carrello HTTP ' + res.status);
        return res.json();
      });
  }

  function isActualFreeGift(item, key) {
    if (!item || Number(item.quantity || 0) < 1) return false;
    var reward = REWARDS[key];
    var sameProduct = item.handle === reward.handle ||
      (reward.pid && Number(item.product_id) === Number(reward.pid));
    var props = item.properties || {};
    var markedGift = String(props._reward) === '1' || String(props._bundle_gift) === 'true';
    // A paid item with the same handle does not fulfill the free-gift promise.
    return !!(sameProduct && markedGift && Number(item.final_line_price) === 0);
  }

  function giftPresent(cart, key) {
    return (cart.items || []).some(function (item) { return isActualFreeGift(item, key); });
  }

  function freeGiftCatalog(key) {
    if (!_giftCatalog[key]) {
      _giftCatalog[key] = fetch(ROOT + 'products/' + REWARDS[key].handle + '.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (res) {
        if (!res.ok) throw new Error(REWARDS[key].handle + ' HTTP ' + res.status);
        return res.json();
      }).then(function (product) {
        if (!product || !product.id || !Array.isArray(product.variants)) {
          throw new Error('Dati del regalo non validi: ' + REWARDS[key].handle);
        }
        REWARDS[key].pid = Number(product.id);
        return product;
      }).catch(function (error) {
        _giftCatalog[key] = null; // Un errore di rete non deve bloccare i tentativi successivi.
        throw error;
      });
    }
    return _giftCatalog[key];
  }

  function freeGiftVariant(key, cart) {
    return freeGiftCatalog(key).then(function (product) {
      var freeVariants = product.variants.filter(function (variant) {
        return variant && variant.available !== false && Number(variant.price) === 0 && Number(variant.id);
      });
      if (!freeVariants.length) throw new Error('Nessuna variante GRATUITA disponibile per ' + REWARDS[key].handle);
      var match;
      if (key === 'm3') {
        var preferredColor = resolveM3Color(cart.items || []);
        match = freeVariants.find(function (variant) { return variantHasColor(variant, preferredColor); });
        if (!match) match = freeVariants.find(function (variant) {
          return variantHasColor(variant, PORTABUSTINE_DEFAULT_COLOR);
        });
      } else {
        // Preferisci la variante del prodotto BauBook già configurata, se gratuita e disponibile.
        match = freeVariants.find(function (variant) {
          return Number(variant.id) === Number(REWARDS.mBook.vid);
        });
      }
      match = match || freeVariants[0];
      REWARDS[key].vid = Number(match.id);
      return REWARDS[key].vid;
    });
  }

  function postGiftCart(url, body) {
    var sections = getSections();
    if (sections) {
      body.sections = sections.join(',');
      body.sections_url = window.location.pathname;
    }
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) return res.text().then(function (detail) {
        throw new Error(url + ' HTTP ' + res.status + ': ' + detail.slice(0, 180));
      });
      return res.json();
    });
  }

  function giftProperties(key) {
    return {
      _reward: '1',
      _reward_label: key === 'mBook' ? 'BAUBUNDLE (-€14,90)' : 'BAUBUNDLE (-€9,99)'
    };
  }

  function checkRewards(cart) {
    // Le singole richieste add.js NON devono partire in parallelo: il secondo
    // regalo deve basarsi sul carrello aggiornato dal primo.
    if (_giftSyncPromise) {
      _giftSyncPending = true;
      return _giftSyncPromise;
    }
    if (_leashLock || _bauRingBusy || _rewardLock.mBook || _rewardLock.m3) {
      _giftSyncPending = true;
      if (!_giftRetryTimer) {
        _giftRetryTimer = setTimeout(function () {
          _giftRetryTimer = null;
          if (_giftSyncPending) {
            _giftSyncPending = false;
            checkRewards();
          }
        }, 240);
      }
      return Promise.resolve();
    }
    _rewardLock.mBook = true;
    _rewardLock.m3 = true;
    var lastCart = cart;
    var modified = false;
    var latestSections = null;
    var hadError = false;

    _giftSyncPromise = (async function () {
      lastCart = await freshCartForGifts();
      syncRewardState(lastCart);
      var target = calcRewardTotal(lastCart) >= REWARDS.m3.threshold;

      // Quando NON si raggiunge la soglia, elimina SOLO le righe automatiche
      // (non i regali di un bundle acquistato separatamente).
      if (!target) {
        for (var k = 0; k < 2; k++) {
          var removeKey = ['mBook', 'm3'][k];
          var existing = (lastCart.items || []).find(function (item) {
            return (item.handle === REWARDS[removeKey].handle ||
              (REWARDS[removeKey].pid && Number(item.product_id) === Number(REWARDS[removeKey].pid))) &&
              item.properties && String(item.properties._reward) === '1' &&
              String(item.properties._bundle_gift) !== 'true';
          });
          if (!existing) continue;
          var removal = await postGiftCart('cart/change.js', { id: existing.key, quantity: 0 });
          latestSections = removal.sections || null;
          modified = true;
          lastCart = await freshCartForGifts();
        }
        return;
      }

      // BauBook e portabustine si aggiungono entrambi, anche se BauRing
      // è già nel carrello e anche quando uno dei due regali è già presente.
      var giftKeys = ['mBook', 'm3'];
      for (var i = 0; i < giftKeys.length; i++) {
        var key = giftKeys[i];
        lastCart = await freshCartForGifts();
        if (calcRewardTotal(lastCart) < REWARDS.m3.threshold) return;
        if (giftPresent(lastCart, key)) continue;

        var variantId;
        try {
          variantId = await freeGiftVariant(key, lastCart);
        } catch (resolveError) {
          hadError = true;
          console.error('[BauReward] ' + key + ': impossibile trovare una variante gratuita disponibile:', resolveError);
          continue; // Il fallimento di un regalo non deve bloccare l'altro.
        }

        for (var attempt = 1; attempt <= 2; attempt++) {
          lastCart = await freshCartForGifts();
          if (calcRewardTotal(lastCart) < REWARDS.m3.threshold) return;
          if (giftPresent(lastCart, key)) break;
          try {
            var response = await postGiftCart('cart/add.js', {
              id: variantId, quantity: 1, properties: giftProperties(key)
            });
            latestSections = response.sections || null;
            modified = true;
            lastCart = await freshCartForGifts();
            if (giftPresent(lastCart, key)) {
              console.log('[BauReward] ' + key + ': REGALO VERIFICATO in /cart.js');
              break;
            }
            throw new Error('Shopify non mostra il regalo nel carrello dopo add.js');
          } catch (addError) {
            hadError = true;
            console.error('[BauReward] ' + key + ': tentativo ' + attempt + '/2:', addError);
          }
        }
      }
      lastCart = await freshCartForGifts();
      var missing = giftKeys.filter(function (key) { return !giftPresent(lastCart, key); });
      if (missing.length) {
        hadError = true;
        console.error('[BauReward] ATTENZIONE: soglia €39,90 raggiunta, regali assenti:', missing.join(', '));
      } else {
        console.log('[BauReward] CONFERMATI entrambi: BauBook e portabustine gratuiti.');
      }
    })().catch(function (error) {
      hadError = true;
      console.error('[BauReward] Sincronizzazione regali non completata:', error);
    }).finally(function () {
      _rewardLock.mBook = false;
      _rewardLock.m3 = false;
      _giftSyncPromise = null;
      if (lastCart && lastCart.items) {
        cacheCart(lastCart);
        syncRewardState(lastCart);
      }
      if (modified && lastCart && lastCart.items) notifyImpact(lastCart, latestSections, false);
      // Il ring rimane gestito dal proprio riconciliatore, ma deve essere
      // eseguito dopo le mutazioni dei due regali, non contemporaneamente.
      if (modified) scheduleRingReconcile();
      if (_giftSyncPending) {
        _giftSyncPending = false;
        setTimeout(function () { checkRewards(); }, 0);
      } else if (hadError) {
        // Riprova dopo un intervallo moderato: niente loop continuo su out-of-stock.
        var now = Date.now();
        if (now >= _giftRetryAfter) {
          _giftRetryAfter = now + 12000;
          setTimeout(function () { checkRewards(); }, 12000);
        }
      }
    });
    return _giftSyncPromise;
  }

  function addReward(key, variantIdOverride, cart) {
    _rewardLock[key]   = true;
    _rewardInCart[key] = true;
    var vid = Number(variantIdOverride || REWARDS[key].vid);
    if (!vid) {
      _rewardLock[key] = false;
      _rewardInCart[key] = false;
      console.warn('[BauReward] ADD annullato: variant ID mancante per', key);
      return;
    }
    console.log('[BauReward] ADD', key, 'vid=' + vid);

    var props = { _reward: '1' };
    if (key === 'm2') props._reward_label = 'BAUBUNDLE (-€9,99)';
    if (key === 'mBook') props._reward_label = 'BAUBUNDLE (-€14,90)';
    if (key === 'm3') props._reward_label = 'BAUBUNDLE (-€9,99)';

    var sections = getSections();
    var body = { id: vid, quantity: 1, properties: props };
    if (sections) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

    cartAdd(body, function (addRes) {
      doFetchCart(function (freshCart) {
        var sec = addRes.sections || null;
        if (sec) freshCart.sections = sec;
        cacheCart(freshCart);
        syncRewardState(freshCart);
        _rewardLock[key] = false;
        console.log('[BauReward] ADD', key, 'done, inCart=' + _rewardInCart[key]);
        notifyImpact(freshCart, sec, true);
      });
    }, function () {
      _rewardInCart[key] = false;
      _rewardLock[key]   = false;
    });
  }

  function removeReward(key, cartSnapshot) {
    var pid = REWARDS[key].pid;
    var line = findRewardLine(cartSnapshot, pid);
    if (line) {
      removeRewardByLine(key, line);
    } else {
      doFetchCart(function (fresh) {
        var freshLine = findRewardLine(fresh, pid);
        if (freshLine) {
          removeRewardByLine(key, freshLine);
        } else {
          _rewardLock[key] = false;
        }
      });
    }
  }

  function removeRewardByLine(key, line) {
    _rewardLock[key]   = true;
    _rewardInCart[key] = false;
    console.log('[BauReward] REMOVE', key, 'lineKey=' + line.key);

    var sections = getSections();
    var body = { id: line.key, quantity: 0 };
    if (sections) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

    cartChange(body, function (updatedCart) {
      cacheCart(updatedCart);
      syncRewardState(updatedCart);
      _rewardLock[key] = false;
      console.log('[BauReward] REMOVE', key, 'done');
      var sec = updatedCart.sections || null;
      notifyImpact(updatedCart, sec, false);
    }, function () {
      _rewardInCart[key] = true;
      _rewardLock[key]   = false;
    });
  }

  function addItem(variantId, onError) {
    var sections = getSections();
    var body = { id: variantId, quantity: 1 };
    if (sections) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }

    cartAdd(body, function (addRes) {
      doFetchCart(function (cart) {
        var sec = addRes.sections || null;
        if (sec) cart.sections = sec;
        cacheCart(cart);
        notifyImpact(cart, sec, false);
        checkRewards(cart);
        checkLeashSize(cart);
        scheduleRingReconcile();
      });
    }, onError);
  }

  function removeItem(variantId, onError) {
    var id = parseInt(variantId, 10);
    var found = _cartItems.find(function (i) { return i.variant_id === id; });

    var doRemove = function (lineKey) {
      if (!lineKey) { if (onError) onError(); return; }
      var sections = getSections();
      var body = { id: lineKey, quantity: 0 };
      if (sections) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
      cartChange(body, function (cart) {
        cacheCart(cart);
        notifyImpact(cart, null, false);
        checkRewards(cart);
        checkLeashSize(cart);
        scheduleRingReconcile();
      }, onError);
    };

    if (found) { doRemove(found.key); return; }
    doFetchCart(function (cart) {
      cacheCart(cart);
      var f = (cart.items || []).find(function (i) { return i.variant_id === id; });
      doRemove(f ? f.key : null);
    });
  }

  function changeVariant(lineKey, newVariantId, onDone, onError) {
    var sections = getSections();

    var originalProps = null;
    var cached = _cartItems.find(function (i) { return i.key === lineKey; });
    if (cached && cached.properties && Object.keys(cached.properties).length > 0) {
      originalProps = cached.properties;
    }

    var isRewardChange = originalProps && (
      String(originalProps._reward) === '1' ||
      String(originalProps._bundle_gift) === 'true'
    );
    if (isRewardChange) {
      _rewardLock.m2 = true;
      _rewardLock.mBook = true;
      _rewardLock.m3 = true;
      console.log('[BauReward] changeVariant su premio — lock attivato');
    }

    var releaseLock = function () {
      if (isRewardChange) {
        _rewardLock.m2 = false;
        _rewardLock.mBook = false;
        _rewardLock.m3 = false;
      }
    };

    var removeBody = { id: lineKey, quantity: 0 };
    if (sections) { removeBody.sections = sections.join(','); removeBody.sections_url = window.location.pathname; }

    cartChange(removeBody, function () {
      var addBody = { id: parseInt(newVariantId, 10), quantity: 1 };
      if (originalProps) addBody.properties = originalProps;
      if (sections) { addBody.sections = sections.join(','); addBody.sections_url = window.location.pathname; }
      cartAdd(addBody, function (addRes) {
        doFetchCart(function (cart) {
          var sec = (addRes && addRes.sections) || null;
          if (sec) cart.sections = sec;
          cacheCart(cart);
          releaseLock();
          notifyImpact(cart, sec, true);
          checkRewards(cart);
          checkLeashSize(cart);
          scheduleRingReconcile();
          if (onDone) onDone(cart);
        });
      }, function () { releaseLock(); if (onError) onError(); });
    }, function () { releaseLock(); if (onError) onError(); });
  }


/* BAURING PER-PETTORINA — un'unica riconciliazione idempotente.
     Usa sempre gli ID Shopify reali e le quantità del carrello, NON un singolo
     findHarnessSize. Non modifica la gestione guinzaglio o portabustine. */
  var _bauRingBusy = false;
  var _bauRingTimer = null;
  var _bauRingPending = false;

  function isRing(item) {
    var cfg = window.__BAU_REWARDS__ || {};
    return item && (item.handle === REWARDS.m2.handle ||
      (cfg.m2ProductId && Number(item.product_id) === Number(cfg.m2ProductId)));
  }

  function ringSizeFromHarness(item) {
    var v = (item.variant_options && item.variant_options[1]) || item.option2 || '';
    return frontRingTargetFromHarnessSize(v);
  }

  function ringVariantByTarget(target) {
    var cfg = window.__BAU_REWARDS__ || {};
    var variants = cfg.m2VariantList || [];
    return variants.find(function (variant) {
      return variant && variant.available !== false && Number(variant.price) === 0 &&
        frontRingVariantMatches(variant, target) && Number(variant.id);
    }) || null;
  }

  /* Restituisce la prossima UNICA mutazione necessaria, non un batch concorrente.
     L'azione viene ricalcolata sul carrello aggiornato dopo ogni mutazione. */
  function planRingCart(cart) {
    var items = cart.items || [];
    // I regali di un bundle nuovo non sopravvivono alla rimozione della sua pettorina.
    var activeBundleIds = new Set(items.filter(function (item) {
      return item.handle === 'pettorina-personalizzata-cane' &&
        item.properties && item.properties._bau_bundle_id;
    }).map(function (item) { return String(item.properties._bau_bundle_id); }));
    var orphan = items.find(function (item) {
      var props = item.properties || {};
      return String(props._bundle_gift) === 'true' && props._bau_bundle_id &&
        !activeBundleIds.has(String(props._bau_bundle_id)) &&
        ['baubook-uscita-perfetta-gratuito', 'portabustine-led-luminoso-gratuito'].indexOf(item.handle) !== -1;
    });
    if (orphan) return { type: 'change', key: orphan.key, quantity: 0, why: 'orphan-bundle-gift' };

    var desired = Object.create(null);
    items.forEach(function (item) {
      if (item.handle !== 'pettorina-personalizzata-cane') return;
      var size = ringSizeFromHarness(item);
      if (!size) return;
      desired[size] = (desired[size] || 0) + Number(item.quantity || 0);
    });
    var ringItems = items.filter(isRing);
    var targets = ['xxs-xs', 's', 'm', 'l-xxl'];
    var byId = Object.create(null);
    targets.forEach(function (target) {
      var variant = ringVariantByTarget(target);
      if (variant) byId[target] = Number(variant.id);
    });

    // Prima aggiungi il pezzo mancante; se l'aggiunta fallisce il regalo
    // preesistente NON viene rimosso (importante nel cambio taglia).
    for (var t = 0; t < targets.length; t++) {
      var target = targets[t];
      var required = desired[target] || 0;
      if (!required) continue;
      var variantId = byId[target];
      if (!variantId) {
        return { type: 'error', why: 'BauRing taglia ' + target + ' non disponibile a €0,00' };
      }
      var already = ringItems.filter(function (item) { return Number(item.variant_id) === variantId; })
        .reduce(function (qty, item) { return qty + Number(item.quantity || 0); }, 0);
      if (already < required) {
        return {
          type: 'add', id: variantId, quantity: required - already,
          properties: { _reward: '1', _reward_label: 'BAUBUNDLE (-€9,99)', _linked_harness_size: target },
          why: 'missing-ring-for-' + target
        };
      }
    }

    // Poi elimina gli esuberi (anche se la pettorina non e' piu' nel carrello).
    // Predilige rimuovere reward automatici prima dei regali propri del bundle.
    for (var i = 0; i < ringItems.length; i++) {
      var line = ringItems[i];
      var lineTarget = targets.find(function (target) {
        return byId[target] && byId[target] === Number(line.variant_id);
      });
      var allowed = lineTarget ? (desired[lineTarget] || 0) : 0;
      var linesSame = ringItems.filter(function (item) {
        return Number(item.variant_id) === Number(line.variant_id);
      });
      var totalSame = linesSame.reduce(function (q, item) { return q + Number(item.quantity || 0); }, 0);
      if (totalSame > allowed) {
        // Scegli la riga automatica, o una riga diversa se questa non e' la migliore.
        var candidate = linesSame.find(function (item) {
          return item.properties && String(item.properties._reward) === '1';
        }) || linesSame.find(function (item) {
          return !(item.properties && String(item.properties._bundle_gift) === 'true');
        }) || linesSame[linesSame.length - 1];
        var excess = totalSame - allowed;
        return {
          type: 'change', key: candidate.key,
          quantity: Math.max(0, Number(candidate.quantity || 0) - excess),
          why: 'extra-or-wrong-ring'
        };
      }
    }
    return null;
  }

  function scheduleRingReconcile() {
    _bauRingPending = true;
    if (_bauRingTimer !== null) clearTimeout(_bauRingTimer);
    _bauRingTimer = setTimeout(function () {
      _bauRingTimer = null;
      if (_bauRingBusy || _rewardLock.mBook || _rewardLock.m3 || _leashLock) {
        // Evita richieste simultanee con il reward portabustine e il leash swap.
        if (_bauRingBusy) return;
        scheduleRingReconcile();
        return;
      }
      if (!_bauRingPending) return;
      _bauRingPending = false;
      _bauRingBusy = true;
      fetch(ROOT + 'cart.js')
        .then(function (response) { if (!response.ok) throw Error('cart ' + response.status); return response.json(); })
        .then(function (cart) {
          var action = planRingCart(cart);
          if (!action || action.type === 'error') {
            if (action) console.error('[BauRing]', action.why);
            return null;
          }
          var sections = getSections();
          var body = action.type === 'add'
            ? { id: action.id, quantity: action.quantity, properties: action.properties }
            : { id: action.key, quantity: action.quantity };
          if (sections) {
            body.sections = sections.join(',');
            body.sections_url = window.location.pathname;
          }
          var url = ROOT + (action.type === 'add' ? 'cart/add.js' : 'cart/change.js');
          return fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          }).then(function (response) {
            if (!response.ok) throw Error('BauRing ' + action.why + ' HTTP ' + response.status);
            return response.json();
          }).then(function (mutation) {
            return fetch(ROOT + 'cart.js').then(function (r) {
              if (!r.ok) throw Error('cart refresh ' + r.status);
              return r.json();
            }).then(function (updated) {
              var sectionsData = mutation.sections || null;
              if (sectionsData) updated.sections = sectionsData;
              cacheCart(updated);
              syncRewardState(updated);
              notifyImpact(updated, sectionsData, false);
              checkRewards(updated);
              checkLeashSize(updated);
              return true;
            });
          });
        })
        .then(function (changed) {
          _bauRingBusy = false;
          if (changed || _bauRingPending) scheduleRingReconcile();
        })
        .catch(function (err) {
          _bauRingBusy = false;
          console.error('[BauRing] Sincronizzazione non completata:', err);
          // non ritentare all'infinito: il prossimo evento carrello riprovera'.
        });
    }, 140);
  }


    /* ─────────────────────────────────────────────────────────────
     LEASH SWAP — guinzaglio riflettente (XS-M) ⇄ guinzaglio
     baugrip (L-XXL), in base alla taglia della Pettorina nel
     carrello. Richiede window.__BAU_LEASH__ (cart-drawer.liquid).
  ───────────────────────────────────────────────────────────── */

  var LEASH_LARGE_SIZES = ['l', 'xl', 'xxl', 'xxxl'];
  var _leashLock = false;

  function getLeashCfg() {
    var cfg = window.__BAU_LEASH__;
    if (!cfg || !cfg.groups) return null;
    return cfg;
  }

  function findHarnessSize(cart) {
    var cfg = getLeashCfg();
    var pHandle = (cfg && cfg.pettorinaHandle) || 'pettorina-personalizzata-cane';
    var item = (cart.items || []).find(function (i) { return i.handle === pHandle; });
    if (!item) return '';
    var raw = (item.variant_options && item.variant_options[1]) || item.option2 || '';
    return raw.toLowerCase().trim();
  }

  function isLargeHarnessSize(size) {
    var value = norm(size).replace(/\s+/g, '');
    if (!value) return false;
    if (LEASH_LARGE_SIZES.indexOf(value) !== -1) return true;
    return /(^|[^a-z])(xxxl|xxl|xl|l)($|[^a-z])/.test(norm(size));
  }

  function targetLeashGroup(size) {
    return isLargeHarnessSize(size) ? 'lxxl' : 'xsm';
  }

  function findLeashItem(cart) {
    var cfg = getLeashCfg();
    if (!cfg) return null;
    var handles = [cfg.groups.xsm.handle, cfg.groups.lxxl.handle];
    return (cart.items || []).find(function (i) { return handles.indexOf(i.handle) !== -1; }) || null;
  }

  function pickLeashVariant(group, preferredColor) {
    var cfg = getLeashCfg();
    if (!cfg || !cfg.groups[group]) return null;
    var variants = cfg.groups[group].variants || [];
    var avail = variants.filter(function (v) { return v.available; });
    if (!avail.length) return null;
    if (preferredColor) {
      var match = avail.find(function (v) {
        return norm(v.color) === norm(preferredColor);
      });
      if (match) return match;
    }
    return avail[0];
  }

  function checkLeashSize(cart) {
    var cfg = getLeashCfg();
    if (!cfg || _leashLock) return;

    var harnessSize = findHarnessSize(cart);
    if (!harnessSize) return; // Pettorina non nel carrello → non tocchiamo il guinzaglio

    var targetGroup  = targetLeashGroup(harnessSize);
    var targetHandle = cfg.groups[targetGroup] && cfg.groups[targetGroup].handle;
    var leashItem    = findLeashItem(cart);

    if (!leashItem || !targetHandle || leashItem.handle === targetHandle) return;

    if (!cfg.groups[targetGroup].productId) {
      console.warn('[BauLeash] productId mancante per gruppo "' + targetGroup + '" — controlla l\'handle prodotto in window.__BAU_LEASH__');
      return;
    }

    var leashColor = (
      leashItem.variant_options && leashItem.variant_options[0]
        ? leashItem.variant_options[0]
        : (leashItem.option1 || '')
    );
    var newVariant = pickLeashVariant(targetGroup, norm(leashColor));
    if (!newVariant) {
      console.warn('[BauLeash] nessuna variante disponibile per il gruppo "' + targetGroup + '"');
      return;
    }

    console.log('[BauLeash] swap', leashItem.handle, '→', targetHandle, 'vid=' + newVariant.id);
    _leashLock = true;

    var sections   = getSections();
    var removeBody = { id: leashItem.key, quantity: 0 };
    if (sections) { removeBody.sections = sections.join(','); removeBody.sections_url = window.location.pathname; }

    cartChange(removeBody, function () {
      var addBody = {
        id: newVariant.id,
        quantity: leashItem.quantity || 1
      };
      if (leashItem.properties && Object.keys(leashItem.properties).length) {
        addBody.properties = leashItem.properties;
      }
      if (sections) { addBody.sections = sections.join(','); addBody.sections_url = window.location.pathname; }
      cartAdd(addBody, function (addRes) {
        doFetchCart(function (freshCart) {
          var sec = addRes.sections || null;
          if (sec) freshCart.sections = sec;
          cacheCart(freshCart);
          _leashLock = false;
          console.log('[BauLeash] swap completato');
          notifyImpact(freshCart, sec, false);
          checkRewards(freshCart);
          scheduleRingReconcile();
        });
      }, function () { _leashLock = false; });
    }, function () { _leashLock = false; });
  }

  document.documentElement.addEventListener('cart:change', function (e) {
    if (_broadcasting) return;
    var cart = e && e.detail && e.detail.cart;
    if (!cart) return;
    cacheCart(cart);
    renderBar(calcRewardTotal(cart), cart);
    checkRewards(cart);
    checkLeashSize(cart);
    scheduleRingReconcile();
    scheduleFrontRingControlLock();
  });

  doFetchCart(function (cart) {
    resolveM2Config();
    resolveM3Config();
    cacheCart(cart);
    syncRewardState(cart);
    renderBar(calcRewardTotal(cart), cart);
    checkRewards(cart);
    checkLeashSize(cart);
    scheduleRingReconcile();
    scheduleFrontRingControlLock();
    console.log('[BauCart] init done, total=' + calcRewardTotal(cart) + ' m3pid=' + REWARDS.m3.pid);
  });

  window.BauRewardBar = { render: function (total) { renderBar(total); } };
  window.BauCartDiagnostics = {
    reconcileRewards: checkRewards,
    resolveM3VariantId: resolveM3VariantId,
    ensureM3VariantId: ensureM3VariantId,
    resolveM2VariantId: resolveM2VariantId,
    ensureM2VariantId: ensureM2VariantId,
    frontRingTargetFromHarnessSize: frontRingTargetFromHarnessSize,
    planRingCart: planRingCart,
    scheduleRingReconcile: scheduleRingReconcile,
    targetLeashGroup: targetLeashGroup
  };

  /* ─────────────────────────────────────────────────────────────
     LINE-ITEM DROPDOWN v9.3 (invariato)
  ───────────────────────────────────────────────────────────── */


  function isFrontRingLineItemElement(li) {
    if (!li || !li.querySelector) return false;
    return !!li.querySelector('a[href*="/products/aggancio-frontale-gratuito"]');
  }

  function lockFrontRingControls() {
    document.querySelectorAll('line-item').forEach(function (li) {
      if (!isFrontRingLineItemElement(li)) return;
      var trigger = li.querySelector('.bau-li__trigger');
      var dropdown = li.querySelector('.bau-li__dropdown');
      if (trigger) {
        trigger.hidden = true;
        trigger.disabled = true;
        trigger.setAttribute('aria-hidden', 'true');
        trigger.style.display = 'none';
      }
      if (dropdown) {
        dropdown.hidden = true;
        dropdown.style.display = 'none';
      }
    });
  }

  function scheduleFrontRingControlLock() {
    [0, 80, 220].forEach(function (delay) {
      setTimeout(lockFrontRingControls, delay);
    });
  }

  function closeLiDropdowns() {
    document.querySelectorAll('.bau-li__dropdown').forEach(function (d) { d.hidden = true; });
    document.querySelectorAll('.bau-li__trigger').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      var arrow = t.querySelector('.bau-bundle__variant-trigger-arrow');
      if (arrow) arrow.classList.remove('bau-bundle__variant-trigger-arrow--open');
    });
  }

  function toggleLiDropdown(trigger) {
    var dd = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!dd) return;
    var wasOpen = !dd.hidden;
    closeLiDropdowns();
    if (!wasOpen) {
      dd.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      var arrow = trigger.querySelector('.bau-bundle__variant-trigger-arrow');
      if (arrow) arrow.classList.add('bau-bundle__variant-trigger-arrow--open');
    }
  }

  function getCurrentLiSize(li) {
    var inActive = li.querySelector(
      '.bau-bundle__dropdown-color-group--active .bau-bundle__size-btn--selected'
    );
    if (inActive) return (inActive.dataset.size || '').trim();

    var anywhere = li.querySelector('.bau-bundle__size-btn--selected');
    if (anywhere) return (anywhere.dataset.size || '').trim();

    return '';
  }

  function findBestSizeBtn(li, targetColor, preferredSize) {
    var group = li.querySelector(
      '.bau-bundle__dropdown-color-group[data-color="' + targetColor + '"]'
    );
    if (!group) return null;

    var available = Array.prototype.slice.call(
      group.querySelectorAll('.bau-bundle__size-btn:not([disabled])')
    );
    if (!available.length) return null;

    if (preferredSize) {
      var pref = preferredSize.toLowerCase().trim();
      for (var i = 0; i < available.length; i++) {
        var s = (available[i].dataset.size || '').toLowerCase().trim();
        if (s === pref) {
          console.log('[BauLI] taglia trovata:', available[i].dataset.size, 'nel colore:', targetColor);
          return available[i];
        }
      }
      console.log('[BauLI] taglia "' + preferredSize + '" non trovata in "' + targetColor + '", fallback a prima disponibile');
    }

    return available[0];
  }

  function handleLiColorChange(li, targetColor) {
    var currentSize = getCurrentLiSize(li);
    console.log('[BauLI] cambio colore → "' + targetColor + '", taglia corrente: "' + currentSize + '"');

    var bestBtn = findBestSizeBtn(li, targetColor, currentSize);
    if (!bestBtn) {
      var dd = li.querySelector('.bau-li__dropdown');
      if (dd) {
        var group = dd.querySelector(
          '.bau-bundle__dropdown-color-group[data-color="' + targetColor + '"]'
        );
        bestBtn = group && group.querySelector('.bau-bundle__color-select-btn:not([disabled])');
      }
    }

    if (bestBtn) {
      handleLiVariantSelect(bestBtn);
    }
  }

  function handleLiVariantSelect(btn) {
    var li = btn.closest('line-item');
    if (!li) return;
    if (isFrontRingLineItemElement(li)) {
      closeLiDropdowns();
      checkFrontRingSize({ items: _cartItems });
      return;
    }
    var trigger = li.querySelector('.bau-li__trigger');
    var lineKey = trigger && trigger.dataset.bauLineKey;
    var newVid = btn.dataset.variantId;
    if (!lineKey || !newVid) return;

    var color = btn.dataset.color || '';
    var size  = btn.dataset.size  || '';
    var newLabel = size ? (color + ' / ' + size) : color;

    _applyLiOptimistic(li, btn, newLabel);
    closeLiDropdowns();

    var triggerText = trigger.querySelector('.bau-bundle__variant-trigger-text');
    var prevLabel   = triggerText ? triggerText.textContent : '';
    trigger.setAttribute('aria-busy', 'true');

    changeVariant(lineKey, newVid,
      function ()  { trigger.removeAttribute('aria-busy'); },
      function ()  {
        trigger.removeAttribute('aria-busy');
        if (triggerText && prevLabel) triggerText.textContent = prevLabel;
      }
    );
  }

  function _applyLiOptimistic(li, btn, label) {
    li.querySelectorAll('.bau-bundle__dropdown-color-group').forEach(function (g) { g.classList.remove('bau-bundle__dropdown-color-group--active'); });
    li.querySelectorAll('.bau-li__color-chip').forEach(function (b) { b.classList.remove('bau-li__color-chip--selected'); });
    li.querySelectorAll('.bau-bundle__size-btn').forEach(function (b) { b.classList.remove('bau-bundle__size-btn--selected'); });
    li.querySelectorAll('.bau-bundle__color-select-btn').forEach(function (b) { b.classList.remove('bau-bundle__color-select-btn--selected'); b.textContent = 'Seleziona'; });
    li.querySelectorAll('.bau-bundle__dropdown-check').forEach(function (c) { c.style.visibility = 'hidden'; });
    var cg = btn.closest('.bau-bundle__dropdown-color-group');
    if (cg) cg.classList.add('bau-bundle__dropdown-color-group--active');
    if (btn.classList.contains('bau-li__color-chip')) btn.classList.add('bau-li__color-chip--selected');
    else if (btn.classList.contains('bau-bundle__size-btn')) btn.classList.add('bau-bundle__size-btn--selected');
    else if (btn.classList.contains('bau-bundle__color-select-btn')) {
      btn.classList.add('bau-bundle__color-select-btn--selected');
      btn.textContent = 'Selezionato';
      var chk = cg && cg.querySelector('.bau-bundle__dropdown-check');
      if (chk) chk.style.visibility = '';
    }
    var triggerText = li.querySelector('.bau-li__trigger .bau-bundle__variant-trigger-text');
    if (triggerText && label) triggerText.textContent = label;
  }



  if ('MutationObserver' in window) {
    var _frontRingUiObserver = new MutationObserver(function () { scheduleFrontRingControlLock(); });
    var _observeFrontRingUi = function () {
      var cartDrawer = document.getElementById('cart-drawer') || document.body;
      if (cartDrawer) _frontRingUiObserver.observe(cartDrawer, { childList: true, subtree: true });
      scheduleFrontRingControlLock();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _observeFrontRingUi, { once: true });
    else _observeFrontRingUi();
  }

  /* ─────────────────────────────────────────────────────────────
     CLICK DELEGATION (cross-sell rimosso — gestito da bau-crossell.js)
  ───────────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var liTrig = t.closest('.bau-li__trigger');
    if (liTrig) { e.preventDefault(); e.stopPropagation(); toggleLiDropdown(liTrig); return; }

    var liDd = t.closest('.bau-li__dropdown');
    if (liDd) {

      var colorChip = t.closest('.bau-li__color-chip');
      if (colorChip && !colorChip.disabled) {
        e.preventDefault(); e.stopPropagation();
        handleLiVariantSelect(colorChip);
        return;
      }

      var sizeBtn = t.closest('.bau-bundle__size-btn');
      if (sizeBtn && !sizeBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        handleLiVariantSelect(sizeBtn);
        return;
      }

      var colorBtn = t.closest('.bau-bundle__color-select-btn');
      if (colorBtn && !colorBtn.disabled) {
        e.preventDefault();
        e.stopPropagation();
        handleLiVariantSelect(colorBtn);
        return;
      }

      var colorRow = t.closest('.bau-bundle__dropdown-color-row');
      if (colorRow) {
        e.preventDefault();
        e.stopPropagation();
        var cg2 = colorRow.closest('.bau-bundle__dropdown-color-group');
        var li2 = liDd.closest('line-item');
        if (cg2 && li2) {
          var targetColor = cg2.dataset.color || '';
          if (cg2.classList.contains('bau-bundle__dropdown-color-group--active')) return;
          handleLiColorChange(li2, targetColor);
        }
        return;
      }

      return;
    }

    if (!t.closest('.bau-li__trigger') && !t.closest('.bau-li__dropdown')) closeLiDropdowns();
  }, true);

})();